import { EN_TRACKING_ACTION, EN_TRACKING_PLATFORM, trackingManager } from '@do/do-web-sdk';
import { EnvConfig } from '../env';

function resolveTrackingPlatform(returnUrl: string): EN_TRACKING_PLATFORM {
    const decodedReturnUrl = decodeURIComponent(returnUrl || '');
    const firstSegment = resolveFirstPathSegment(decodedReturnUrl);

    if (firstSegment === 'drawing') {
        return EN_TRACKING_PLATFORM.DRAWING2D;
    }

    if (firstSegment === 'client') {
        return EN_TRACKING_PLATFORM.CLIENT;
    }

    if (firstSegment === 'shanshe') {
        return EN_TRACKING_PLATFORM.WORKBENCH;
    }

    return EN_TRACKING_PLATFORM.WORKBENCH;
}

function resolveFirstPathSegment(url: string): string {
    try {
        const pathname = new URL(url).pathname || '';
        return pathname.split('/').filter(Boolean)[0]?.toLowerCase() ?? '';
    } catch {
        const normalized = url.replace(/^https?:\/\/[^/]+/i, '');
        return normalized.split('/').filter(Boolean)[0]?.toLowerCase() ?? '';
    }
}

function resolveTenantId(returnUrl: string): string {
    const decodedReturnUrl = decodeURIComponent(returnUrl || '');
    const tenantIdMatch = decodedReturnUrl.match(/[?&]tenantId=([^&]+)/i);
    return tenantIdMatch?.[1] ?? '0';
}

export async function track(returnUrl: string, loginResult: any): Promise<void> {
    try {
        const platform = resolveTrackingPlatform(returnUrl);
        if (!platform) {
            console.error('Unknown platform');
            return;
        }
        const tenantId = resolveTenantId(returnUrl);
        if (!tenantId) {
            console.error('Unknown tenantId');
            return;
        }

        const { token } = loginResult;
        if (!token) {
            console.error('Unknown token');
            return;
        }

        trackingManager.init({
            platform,
            tenantId,
            token,
            baseUrl: EnvConfig.getBaseUrl(),
        });

        await trackingManager.track(EN_TRACKING_ACTION.LOGIN, {
            includeDeviceMeta: true,
        });
    } catch (error) {
        console.error('track error', error);
    }
}
